import { Autocomplete, Grid, TextField } from "@mui/material";

interface FilteredNode {
  nodeId: string;
  nodeName: string;
  nodeIP: string;
  location?: string;
}

type NodeProps = {
  selectedNodeId: string;
  filteredNodes: FilteredNode[];
  onChange: (node: {
    nodeId: string;
    nodeName: string;
    nodeIP: string;
  }) => void;
  error?: boolean;
  helperText?: string;
  size?: "small" | "medium";
  fullWidth?: boolean;
  disabled?: boolean;
};

const DeviceTemplateNodeSelect = ({
  selectedNodeId,
  filteredNodes,
  onChange,
  error = false,
  helperText = "",
  size = "medium",
  fullWidth = true,
  disabled = false,
}: NodeProps) => {
  const selectedNode =
    filteredNodes.find(node => node.nodeId === selectedNodeId) ?? null;

  const autocomplete = (
    <Autocomplete
      disableClearable={selectedNode !== null}
      disabled={disabled}
      size={size}
      fullWidth={fullWidth}
      value={selectedNode}
      onChange={(_e, newNode) => {
        if (newNode) {
          onChange(newNode);
        }
      }}
      options={filteredNodes}
      groupBy={option => option.location ?? ""}
      getOptionLabel={option => option.nodeName}
      isOptionEqualToValue={(opt, val) => opt.nodeId === val.nodeId}
      sx={{ minWidth: fullWidth ? 180 : 140 }}
      renderInput={params => (
        <TextField
          {...params}
          label="Node"
          error={error}
          helperText={error ? helperText : ""}
        />
      )}
    />
  );

  // Wrap in Grid item for backward compatibility with existing usages
  if (fullWidth) {
    return (
      <Grid item xs={12}>
        {autocomplete}
      </Grid>
    );
  }

  return autocomplete;
};

export default DeviceTemplateNodeSelect;
